import { Swiper } from "swiper";
import { Navigation, Pagination, Keyboard, EffectFade, FreeMode } from "swiper/modules";
import "swiper/css";
import 'swiper/css/effect-fade';

export default function initSwiper() {
    const swipers = document.querySelectorAll(".swiper-component");
    
    if (!swipers) return;
    
    swipers.forEach((swiper) => {
        const data = swiper.dataset

        new Swiper(swiper.querySelector(".swiper"), {
            modules: [Navigation, Pagination, Keyboard, EffectFade, FreeMode],
            effect: "slide",
            draggable: true,
            grabCursor: true,
            allowTouchMove: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            navigation: {
                nextEl: swiper.querySelector(".swiper-button-next"),
                prevEl: swiper.querySelector(".swiper-button-prev"),
                disabledClass: "disabled",
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
                renderFraction: (currentClass, totalClass) => {
                    return `<span class="${currentClass}"></span>` +
                           ' / ' +
                           `<span class="${totalClass}"></span>`;
                },
                formatFractionCurrent: (number) => {
                    return number < 10 ? `0${number}` : number;
                },
                formatFractionTotal: (number) => {
                    return number < 10 ? `0${number}` : number;
                }
            },
            slidesPerView: data.type === "personnel" ? 1.15 : 1,
            spaceBetween: data.type === "personnel" ? 25 : 27,
            freeMode: data.type === "personnel",
            breakpoints: {
                480: {
                    slidesPerView: data.type === "personnel" ? 1.75 : 1,
                },
                768: {
                    slidesPerView: data.type === "personnel" ? 2.5 : 1,
                },
                1024: {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true, // Optional: Enable cross-fade
                    },
                    slidesPerView: data.type === "personnel" ? 2.5 : 1,
                    slidesPerGroup: data.type === "personnel" ? 2 : 1,
                },
                1200: {
                    slidesPerView: data.type === "personnel" ? 3.22 : 1,
                    slidesPerGroup: data.type === "personnel" ?  3 : 1,
                    freeMode: false,
                },
            },
        });
    });
}